import { Router, UrlTree } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class TeamValidationGuard {
    constructor(router) {
        this.router = router;
    }
    canActivate(route, state) {
        return this.validateTeamAccess(route);
    }
    canActivateChild(childRoute, state) {
        return this.validateTeamAccess(childRoute);
    }
    canLoad(route, segments) {
        if (segments.length > 0) {
            const teamFromUrl = segments[0].path;
            const isValid = this.validateTeamFromSubdomain(teamFromUrl);
            if (isValid instanceof UrlTree) {
                this.router.navigateByUrl(isValid);
                return false;
            }
            return isValid;
        }
        return true;
    }
    validateTeamAccess(route) {
        const teamFromUrl = route.paramMap.get('team') || (route.parent && route.parent.paramMap.get('team'));
        if (!teamFromUrl) {
            return true;
        }
        return this.validateTeamFromSubdomain(teamFromUrl);
    }
    validateTeamFromSubdomain(teamFromUrl) {
        try {
            const hostname = window.location.hostname;
            const subdomainMatch = hostname.match(/^([^.]+)\./);
            const subdomain = subdomainMatch ? subdomainMatch[1] : null;
            if (!subdomain) {
                return true;
            }
            if (subdomain.toLowerCase() === teamFromUrl.toLowerCase()) {
                return true;
            }
            return this.router.parseUrl('/404');
        }
        catch (error) {
            console.error('Error validating team access:', error);
            return true;
        }
    }
}
TeamValidationGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TeamValidationGuard_Factory() { return new TeamValidationGuard(i0.ɵɵinject(i1.Router)); }, token: TeamValidationGuard, providedIn: "root" });
